export const enum PaymentConsolidationAccountingStatus {
    All = -1,
    PendingAccounting = 1,
    AccountingComplate = 2,
    NeedRecalculate = 3,
    TransferToAxaptaComplete = 4,
}
